export default __webpack_public_path__ + "assets/images/turtle-blue-fc435cfd072680104f101b6e0f210d4d.svg";